module.exports = __webpack_public_path__ + "img/a68fc4ee7b94d07852101a2d7b14cba1.a68fc4ee.png";